import { GreeksFeesMetricsTabContentPresentation } from 'components/common-form/sidePanel/info/QuoteInfos/GreeksFeesMetricsTabContent/GreeksFeesMetricsTabContentPresentation';
import { RawQuoteInfos } from 'components/common-form/sidePanel/info/QuoteInfos/QuoteInfos';

import { connectGreeksFeesMetricsTabContentController } from './GreeksFeesMetricsTabContent.connect';
import { connectQuoteInfos } from './QuoteInfos.connect';

export const QuoteInfos = connectQuoteInfos(RawQuoteInfos);
export const GreeksFeesMetricsTabContent = connectGreeksFeesMetricsTabContentController(
  GreeksFeesMetricsTabContentPresentation,
);
